import { registerEventListeners } from "@/game-eft/handle-messages.mjs";

export function setup() {
  registerEventListeners();
}

export function teardown() {
  // Do nothing
}
